<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>{{ $store.state.table.perjanjian }}</strong>
          </p>
        </template>
        <CRow>
          <CCol cols="12" md="12" lg="12">
            <b-button variant="primary" class="mb-4" v-b-modal.modal-input>
              <CIcon name="cil-plus" />
              {{ $store.state.table.tambahModal }}
            </b-button>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #namaTanggalMulaiKontrak-filter>
                <date-picker style="width: 100%" v-model="filter.tanggalMulaiKontrak" format="DD MMMM YYYY"></date-picker>
              </template>
              <template #namaTanggalSelesaiKontrak-filter>
                <date-picker style="width: 100%" v-model="filter.tanggalSelesaiKontrak" format="DD MMMM YYYY"></date-picker>
              </template>
              <template #namaStatusPerjanjian-filter>
                <b-form-select v-model="filter.statusPerjanjian" :options="optionsStatusPerjanjian"></b-form-select>
              </template>
              <template #namaStatusPerjanjianAktif-filter>
                <b-form-select v-model="filter.statusPerjanjianAktif" :options="optionsStatusPerjanjianAktif"></b-form-select>
              </template>
              <template #Actions="{ item }">
                <td class="flex">
                  <b-button
                    v-if="item.statusPerjanjianAktif == 8"
                    variant="warning"
                    class="mr-1 mb-1"
                    v-c-tooltip.hover.click="'Edit Data'"
                    v-b-modal.modal-edit
                    @click="(data = item), setEdit(), (edit = !edit)"
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                    ><CIcon name="cil-pencil"
                  /></b-button>

                  <b-button variant="info" class="mr-1 mb-1" v-c-tooltip.hover.click="'Detail'" v-b-modal.modal-detail @click="(data = item), setEdit(), (detail = !detail)"
                    ><CIcon name="cil-info" />{{ item.actions }}</b-button
                  >

                  <b-button
                    v-if="(item.statusPerjanjianAktif == 0 || item.statusPerjanjianAktif == 8) && !item.isMutasi"
                    variant="outline-danger"
                    class="mr-1 mb-1"
                    v-c-tooltip.hover.click="'Status'"
                    @click="(data = item), setEdit(), $bvModal.show('modal-status-perjanjian-kerja')"
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                    ><CIcon name="cil-check"
                  /></b-button>

                  <b-button
                    variant="success"
                    class="mr-1 mb-1"
                    v-c-tooltip.hover.click="'Upload'"
                    v-b-modal.modal-dokumen-perjanjian-kerja
                    @click="(data = item), setEdit(), (detail = !detail)"
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                    ><CIcon name="cil-paperclip"
                  /></b-button>

                  <b-button
                    variant="secondary"
                    class="mr-1 mb-1"
                    v-c-tooltip.hover.click="'Print Data'"
                    v-b-modal.modal-print
                    @click="setPrint(item)"
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                    ><CIcon name="cil-print"
                  /></b-button>

                  <b-button
                    v-if="item.statusPerjanjianAktif == 8 && !item.isMutasi"
                    variant="danger"
                    class="mr-1 mb-1"
                    v-c-tooltip.hover.click="'Hapus Data'"
                    v-b-modal.modal-delete
                    @click="data = item"
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                    ><CIcon name="cil-trash"
                  /></b-button>
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <ModalInput :karyawan="listKaryawan" :gapok="listGaji" :manajemen="listManajemen" :listMitra="listMitra" :listDivisi="listDivisi" @alert="triggerAlert($event)" />
    <ModalEdit :data="data" :listMitra="listMitra" :listDivisi="listDivisi" :gapok="listGaji" :edit="edit" :karyawan="listKaryawan" :manajemen="listManajemen" @alert="triggerAlert($event)" />
    <ModalDetail :data="data" :detail="detail" />
    <ModalDokumen :data="data" :detail="detail" @alert="triggerAlert($event)" />
    <ModalStatus :data="data" :detail="detail" @alert="triggerAlert($event)" />
    <ModalDelete :data="data" :detail="detail" @alert="triggerAlert($event)" />
    <ModalPrint :printData="printData" :manajemen="listManajemen" />
  </CRow>
</template>

<script>
import ModalInput from "./modalInput.vue";
import ModalEdit from "./modalEdit.vue";
import ModalDetail from "./modalDetail.vue";
import ModalDokumen from "./modalDokumen.vue";
import ModalStatus from "./modalStatus.vue";
import ModalDelete from "./modalDelete.vue";
import ModalPrint from "./modalPrint.vue";
import debounce from "lodash/debounce";

import { ipBackend } from "@/ipBackend.js";
export default {
  components: {
    ModalEdit,
    ModalDetail,
    ModalInput,
    ModalDokumen,
    ModalStatus,
    ModalDelete,
    ModalPrint,
  },
  name: "perjanjian",
  data() {
    return {
      edit: null,
      detail: null,
      printData: null,
      data: {},
      listKaryawan: [],
      listMitra: [],
      listManajemen: [],
      listGaji: [],
      listDivisi: [],
      items: [],

      filter: {
        tanggalMulaiKontrak: null,
        tanggalSelesaiKontrak: null,
        statusPerjanjian: null,
        statusPerjanjianAktif: null,
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
      optionsStatusPerjanjianAktif: [
        { value: null, text: "Pilih" },
        { value: "0", text: "Aktif" },
        { value: "1", text: "Habis Kontrak" },
        { value: "2", text: "Diberhentikan" },
        { value: "3", text: "Resign" },
        { value: "4", text: "Diperpanjang" },
        { value: "5", text: "Mutasi Jabatan" },
        { value: "6", text: "Meninggal" },
        { value: "7", text: "Tanpa Keterangan" },
        { value: "8", text: "Belum Aktif" },
        { value: "9", text: "Pensiun" },
      ],
      optionsStatusPerjanjian: [
        { value: null, text: "Pilih" },
        { value: "0", text: "Kontrak" },
        { value: "1", text: "Permanen" },
        { value: "2", text: "Alih daya" },
      ],
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    fields() {
      let x = [
        {
          key: "no",
          label: this.$store.state.table.no,
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "nomorSuratPerjanjian",
          label: this.$store.state.table.nomorSuratPerjanjian,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaKaryawan",
          label: this.$store.state.table.namaKaryawan,
          _style: "max-width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "masaKontrak",
          label: this.$store.state.table.masaKontrak,
          _style: "max-width: 5%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaTanggalMulaiKontrak",
          label: this.$store.state.table.namaTanggalMulaiKontrak,
          _style: "max-width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaTanggalSelesaiKontrak",
          label: this.$store.state.table.namaTanggalSelesaiKontrak,
          _style: "max-width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaStatusPerjanjian",
          label: this.$store.state.table.namaStatusPerjanjian,
          _style: "max-width: 9%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaStatusPerjanjianAktif",
          label: this.$store.state.table.namaStatusPerjanjianAktif,
          _style: "max-width: 8%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: this.$store.state.table.Actions,
          _style: "min-width: 20%;",
          class: "table-option-5 text-center",
          filter: false,
          sorter: false,
        },
      ];

      if (this.$store.state.role_aktif.kodeRole == "super") {
        x.splice(1, 0, {
          key: "namaMitra",
          label: "Mitra",
          _style: "max-width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        });
      }
      return x;
    },
  },
  mounted() {
    this.getDatas();
    this.getGaji();
    this.getDivisi();
    this.getMitra();
    this.getManajemen();
    this.getKaryawan();
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    filter: {
      deep: true,
      handler() {
        this.debounceGetDatas();
      },
    },
  },
  methods: {
    debounceGetDatas: debounce(function () {
      this.getDatas();
    }, 1000),
    onFilter(x) {
      const vm = this;
      vm.filter = x;
      vm.currentPage = 1;
      this.debounceGetDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listPerjanjian = await vm.$axios.post("suratPerjanjianKerja/listPerHalaman", {
        ...vm.filter,
        tanggalMulaiKontrak: vm.filter.tanggalMulaiKontrak ? vm.$moment(vm.filter.tanggalMulaiKontrak).format("YYYY-MM-DD") : null,
        tanggalSelesaiKontrak: vm.filter.tanggalSelesaiKontrak ? vm.$moment(vm.filter.tanggalSelesaiKontrak).format("YYYY-MM-DD") : null,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      // console.log("listPerjanjian", listPerjanjian);
      vm.items =
        listPerjanjian.data.status == 200
          ? listPerjanjian.data.data.map((x, idx) => {
              vm.optionsStatusPerjanjian.forEach((item) => {
                if (x.statusPerjanjian == item.value) x.namaStatusPerjanjian = item.text;
              });
              vm.optionsStatusPerjanjianAktif.forEach((item) => {
                if (x.statusPerjanjianAktif == item.value) x.namaStatusPerjanjianAktif = item.text;
              });
              return {
                ...x,
                id: x.suratPerjanjianKerjaId,
                namaMitra: x.namaMitra || " - ",
                nomorSuratPerintah: x.nomorSuratPerintah || null,
                posisiManajemenId: x.posisiManajemenId || null,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                namaTanggalMulaiKontrak: vm.$moment(x.tanggalMulaiKontrak).format("LL"),
                namaTanggalSelesaiKontrak: vm.$moment(x.tanggalSelesaiKontrak).format("LL"),
                // edit
                dataKaryawanId: { namaKaryawan: x.namaKaryawan, dataKaryawanId: x.dataKaryawanId },
                tanggalMulaiKontrak: new Date(x.tanggalMulaiKontrak),
                tanggalSelesaiKontrak: new Date(x.tanggalSelesaiKontrak),
              };
            })
          : [];
      vm.totalRows = parseInt(listPerjanjian.data.count);
      vm.loading = false;
    },
    async getKaryawan() {
      let vm = this;
      let listKaryawan = await vm.$axios.post("dataKaryawan/listDataKaryawanBelumDitempatkanPerHalaman", {
        halaman: "0",
        jumlah: 10000,
        statusPenempatan: 0,
      });
      // console.log("listKaryawan", listKaryawan);
      vm.listKaryawan =
        listKaryawan.data.status == 200
          ? listKaryawan.data.data.map((x) => {
              return {
                ...x,
                namaKaryawan: x.namaKaryawan + " - " + x.namaPosisi,
              };
            })
          : [];
    },
    async getGaji() {
      let vm = this;
      let listGaji = await vm.$axios.post("masterGaji/list");
      console.log("listGaji", listGaji);
      vm.listGaji =
        listGaji.data.status == 200
          ? listGaji.data.data.map((x) => {
              let nominalGaji = x.nominalGaji.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
              return {
                ...x,
                id: x.masterGajiId,
                value: x.masterGajiId,
                text: x.namaGaji + " - " + "Rp. " + nominalGaji,
              };
            })
          : [];
    },
    async getMitra() {
      let vm = this;
      let listMitra = await vm.$axios.get("mitra/list");
      vm.listMitra = listMitra.data.status == 200 ? listMitra.data.data : [];
    },
    async getDivisi() {
      let vm = this;
      const listDivisi = await vm.$axios.post("masterDivisi/list");
      vm.listDivisi =
        listDivisi.data.status == 200
          ? listDivisi.data.data.map((x) => {
              return {
                ...x,
                id: x.masterDivisiId,
              };
            })
          : [];
    },
    async getManajemen() {
      let vm = this;
      let listManajemen = await vm.$axios.post("masterManajemen/list");
      vm.listManajemen = listManajemen.data.status == 200 ? listManajemen.data.data : [];
    },
    setEdit() {
      let vm = this;
      for (let i = 0; i < vm.listKaryawan.length; i++) {
        if (vm.data.dataKaryawanId == vm.listKaryawan[i].dataKaryawanId) {
          vm.data.dataKaryawanIdEdit = vm.listKaryawan[i];
        }
      }
      vm.data.tanggalMulaiKontrakEdit = vm.$moment(vm.data.tanggalMulaiKontrak).format("DD/MM/YYYY");
      vm.data.tanggalSelesaiKontrakEdit = vm.$moment(vm.data.tanggalSelesaiKontrak).format("DD/MM/YYYY");
    },
    setPenempatan(x) {
      // if (x.capemId) {
      //   x.alamatPenempatan = x.alamatCapem;
      // } else {
      if (x.cabangId) {
        x.alamatPenempatan = x.alamatCabang;
      }
      // else {
      //     if (x.koordinatorId) {
      //       x.alamatPenempatan = x.alamatKoordinator;
      //     } else {
      //       x.alamatPenempatan = x.alamatMitra;
      //     }
      //   }
      // }
    },
    async setPrint(x) {
      let vm = this;
      let printdata = await vm.$axios.get("suratPerjanjianKerja/cetakSuratPerjanjian/" + x.suratPerjanjianKerjaId);
      // console.log(printdata.data.data, "suratPerj");
      vm.printData = printdata.data.data;
      this.setPenempatan(vm.printData);
      vm.printData.tanggal = vm.$moment().format("LL");
      vm.printData.tanggal2 = vm.$moment(vm.printData.tanggalMulaiKontrak).format("DD-MM-YYYY");
      vm.printData.tanggalMulaiKontrakAsli = vm.$moment(vm.printData.tanggalMulaiKontrak).format("DD-MM-YYYY");
      vm.printData.tanggalLahirKaryawanPrint = vm.$moment(vm.printData.tanggalLahirKaryawan).format("LL");
      vm.printData.namaPejabatManajemenModal = "";
      vm.printData.posisiManajemenModal = "";
    },
    print(data) {
      window.open(ipBackend + "suratPerjanjianKerja/cetakSuratPerjanjian/" + data.suratPerjanjianKerjaId, "_blank");
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
